import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useFormikContext } from 'formik'
import { ShowIf } from '@ztechapps/webui.util'
import { useHistory } from '@ztechapps/common.hook'
import { useContext } from './Context'

export const ChangePasswordButton = () => {
  const { isSubmitting, isValid, status } = useFormikContext()
  const history = useHistory()
  const { navigateTo } = useContext()

  const submitSuccess = status === 'success'

  return (
    <>
      <ShowIf condition={submitSuccess}>
        <BusyButton
          bsStyle="primary"
          isBusy={isSubmitting}
          disabled={!isValid}
          onClick={() => {
            history.push(navigateTo)
          }}
        >
          Sign-in
        </BusyButton>
      </ShowIf>
      <ShowIf condition={!submitSuccess}>
        <BusyButton type="submit" bsStyle="primary" isBusy={isSubmitting} disabled={!isValid}>
          Change password
        </BusyButton>
      </ShowIf>
    </>
  )
}
